import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface LineChartProps {
  categories: string[];
  series: Array<{ name: string; data: number[]; color?: string }>;
  smooth?: boolean;
  stacked?: boolean;
  height?: number | string;
  loading?: boolean;
  color?: string;
  showGrid?: boolean;
  xAxisLabel?: string;
  yAxisLabel?: string;
}

export function LineChart({
  categories,
  series,
  smooth = true,
  stacked,
  height,
  loading,
  color,
  showGrid = true,
  xAxisLabel,
  yAxisLabel,
}: LineChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'axis' },
    legend: { bottom: 0 },
    grid: { left: 50, right: 20, top: 20, bottom: 40, containLabel: true },
    xAxis: {
      type: 'category',
      data: categories,
      boundaryGap: false,
      name: xAxisLabel,
      splitLine: showGrid ? undefined : { show: false },
    },
    yAxis: {
      type: 'value',
      name: yAxisLabel,
      splitLine: showGrid ? undefined : { show: false },
    },
    series: series.map((s) => ({
      name: s.name,
      type: 'line',
      smooth,
      stack: stacked ? 'stack' : undefined,
      data: s.data,
      itemStyle: { color: color ?? s.color },
      areaStyle: stacked ? { opacity: 0.3 } : undefined,
    })),
  };
  return <EChart option={option} height={height} loading={loading} />;
}
